module.exports = __webpack_public_path__ + "img/China-3.d6a0bca9.jpg";